@if (approvalConfig()) {
  <div class="approval-flow-root">
    @switch (currentState()) {
      <!-- Approval State -->
      @case (ApprovalFlowState.APPROVAL) {
        <div class="approval-flow-container">
          <!-- Swap Approval (custom UI for swap transactions) -->
          @if (isSwapTransaction() && swapContext()) {
            <app-swap-approval
              [swapContext]="swapContext()!"
              [isLoading]="isLoading()"
              [canApprove]="isAvailableForApproval()"
              (approve)="onAccept()"
              (reject)="onReject()"
            >
              @if (isActionHasL2PriorityFee()) {
                <l2-priority-fee-selection
                  [action]="approvalConfig()!.action"
                  [wallet]="wallet()"
                  (priorityFeeSelected)="setL2CurrentPriorityFee($event)"
                  (gasLimitSelected)="setL2GasLimit($event)"
                />
              }
            </app-swap-approval>
          } @else {
            <div class="approval-flow-content">
              <!-- Transaction Header -->
              <div class="transaction-header">
                @if (isActionHasPriorityFee()) {
                  <h2>Transaction Review</h2>
                }
                @if (!isActionHasPriorityFee()) {
                  <h2>Action Review</h2>
                }
                <p>Please review the details below before proceeding.</p>
              </div>
              <!-- Action Details Section -->
              @if (actionDisplay()) {
                <div class="action-overview-card">
                  <div class="action-header">
                    <h3 class="action-title">{{ actionDisplay()!.title }}</h3>
                    @if (actionDisplay()!.subtitle) {
                      <h4 class="action-subtitle">
                        {{ actionDisplay()!.subtitle }}
                      </h4>
                    }
                  </div>
                  <!-- Action Detail Rows -->
                  <div class="action-details-grid">
                    @for (row of actionDisplay()!.rows; track row) {
                      <!-- Input Fields (checkboxes) -->
                      @if (row.inputField) {
                        <div class="detail-card checkbox-container">
                          @if (
                            row.inputField.fieldType === InputFieldType.CHECKBOX
                          ) {
                            <app-checkbox-input
                              [checked]="
                                additionalParams[
                                  row.inputField.fieldParam
                                ] ?? (row.fieldValue === 'true')
                              "
                              (checkedChange)="
                                additionalParams[row.inputField.fieldParam] =
                                  $event
                              "
                            >
                              {{ row.fieldName }}
                            </app-checkbox-input>
                          }
                        </div>
                      } @else {
                        <!-- Signing Message Detail -->
                        @if (row.isCodeBlock) {
                          <div class="detail-card detail-signing-message">
                            <div class="detail-label">{{ row.fieldName }}</div>
                            <div class="detail-value">{{ row.fieldValue }}</div>
                          </div>
                        }
                        <!-- Regular Detail -->
                        @if (!row.isCodeBlock) {
                          <div class="detail-card">
                            <div class="detail-label">{{ row.fieldName }}</div>
                            <div class="detail-value">{{ row.fieldValue }}</div>
                          </div>
                        }
                      }
                      <!-- Regular Detail Rows -->
                    }
                  </div>
                </div>
              } @else {
                <div class="unknown-action-card">
                  <kc-icon
                    iconClass="icon-warning"
                    size="lg"
                    color="var(--orange-20)"
                  />
                  <h3>Unknown Action</h3>
                  <p>
                    This action type is not recognized. Please proceed with
                    caution.
                  </p>
                </div>
              }
              <!-- Priority Fee Selection -->
              @if (isActionHasPriorityFee()) {
                <priority-fee-selection
                  [action]="approvalConfig()!.action"
                  [wallet]="wallet()"
                  (priorityFeeSelected)="setCurrentPriorityFee($event)"
                />
              }
              <!-- Priority Fee Selection -->
              @if (isActionHasL2PriorityFee()) {
                <l2-priority-fee-selection
                  [action]="approvalConfig()!.action"
                  [wallet]="wallet()"
                  (priorityFeeSelected)="setL2CurrentPriorityFee($event)"
                  (gasLimitSelected)="setL2GasLimit($event)"
                />
              }
              <!-- Action Buttons - Last element that gets pushed to bottom -->
              <div class="action-buttons-section">
                <div class="action-buttons">
                  <kc-button
                    [text]="isLoading() ? 'Processing...' : 'Approve'"
                    variant="primary"
                    size="m"
                    [isFullWidth]="true"
                    [isDisabled]="!isAvailableForApproval()"
                    [isLoading]="isLoading()"
                    (buttonClick)="onAccept()"
                    class="accept-button"
                  />
                  <kc-button
                    [text]="'Reject'"
                    variant="secondary"
                    size="m"
                    [isFullWidth]="true"
                    [isDisabled]="isLoading()"
                    (buttonClick)="onReject()"
                    class="reject-button"
                  />
                </div>
              </div>
            </div>
          }
          <!-- Regular Approval -->
        </div>
      }
      <!-- Processing/Loading State -->
      @case (ApprovalFlowState.PROCESSING) {
        <app-approval-loading-page />
      }
      <!-- Success State -->
      @case (ApprovalFlowState.SUCCESS) {
        <app-approval-success-page [actionResult]="approvalConfig()!.result!" />
      }
      <!-- Error State -->
      @case (ApprovalFlowState.ERROR) {
        <div class="error-container">
          <div class="error-content">
            <div class="error-icon-wrapper">
              <kc-icon iconClass="icon-warning" size="lg" color="#f87171" />
            </div>
            <h2>Transaction Failed</h2>
            <div class="error-message">
              {{ approvalConfig()?.error || "An unexpected error occurred" }}
            </div>
            <kc-button
              [text]="'Close'"
              variant="secondary"
              size="m"
              [isFullWidth]="true"
              (buttonClick)="approvalFlowService.closeApproval()"
            />
          </div>
        </div>
      }
    }
  </div>
}
